<template>
  <div class="personalInfo">
    <!-- 头部简单信息 -->
    <div class="detail-head">
      <input type="file" hidden id="oFile" />
      <div class="avator" @click="changeAvatar">
        <el-avatar :size="100" :src="avatar || circleUrl"></el-avatar>
        <span class="camera">
          <img class="cameraIcon" :src="cameraIcon" alt="" srcset="" />
        </span>
      </div>
      <div class="user-info">
        <el-descriptions :column="2">
          <el-descriptions-item label="用户名称" span="2" class="right-align">{{
            realName || "-"
          }}</el-descriptions-item>
          <el-descriptions-item label="账号ID" class="right-align">{{
            id || "-"
          }}</el-descriptions-item>
          <el-descriptions-item label="用户角色" class="right-align">{{
            roleName || "-"
          }}</el-descriptions-item>
          <el-descriptions-item label="注册时间" class="right-align">{{
            create_time || "-"
          }}</el-descriptions-item>
          <el-descriptions-item label="上次登录" class="right-align">{{
            LastloginTime || "-"
          }}</el-descriptions-item>
        </el-descriptions>
      </div>
      <!-- <div class="info-keys">
        <div>用户名称:</div>
        <div style="padding: 16px 0">账号ID:</div>
        <div>注册时间:</div>
      </div>
      <div class="info-values">
        <div>{{ realName }}</div>
        <div style="padding: 18px 0">{{ id }}</div>
        <div>{{ create_time }}</div>
      </div>
      <div class="info-keys">
        <div>用户角色:</div>
        <div style="padding: 16px 0">上次登录:</div>
      </div>
      <div class="info-values">
        <div>
          {{ roleName || "--" }}
        </div>
        <div style="padding: 16px 0">
          {{ LastloginTime || "" }}
        </div> -->
      <!-- </div> -->
    </div>
    <div class="detail-body">
      <div class="type-buttons">
        <span class="type-button active-button">基础信息</span>
      </div>
      <!-- 基础信息 -->
      <div class="base-info">
        <div class="detail-item">
          <span class="item-title">用户手机号</span>
          <span class="item-content">
            <span class="content-info"
              >已绑定：{{ encryptPhoneNumber(userName) || "-" }}</span
            >
            <span
              v-permission="'phonenumber_edit'"
              class="content-edit"
              @click="showDialog('userName')"
              >修改</span
            >
          </span>
        </div>
        <div class="detail-item">
          <span class="item-title">用户名称</span>
          <span class="item-content">
            <span class="content-info">{{ realName || "-" }}</span>
            <span
              v-permission="'name_edit'"
              class="content-edit"
              @click="showDialog('realName')"
              >修改</span
            >
          </span>
        </div>
        <div class="detail-item">
          <span class="item-title">工作邮箱</span>
          <span class="item-content">
            <span class="content-info" v-if="email">已设置：{{ email }}</span>
            <span class="content-info" v-else
              >未设置，工作邮箱用于接收系统提醒消息。</span
            >
            <span
              v-permission="'email_edit'"
              class="content-edit"
              @click="showDialog('email')"
              >设置</span
            >
          </span>
        </div>
        <div class="detail-item" v-if="!fromAccountList">
          <span class="item-title">登录密码</span>
          <span class="item-content">
            <span class="content-info">
              已设置。密码至少8位字符，支持数字、字母和除空格外的特殊字符，且必须同时包含数字和字母和字符。</span
            >
            <span
              v-if="!fromAccountList"
              class="content-edit"
              @click="showDialog('password')"
            >
              修改</span
            >
          </span>
        </div>
      </div>
      <!-- 修改手机号弹窗 -->
      <el-dialog
        title="修改手机号"
        width="25%"
        top="30vh"
        :center="true"
        :close-on-click-modal="false"
        :visible.sync="showUserNameDialog"
        @close="dialogValue1.value = ''"
      >
        <el-form :model="dialogValue1">
          <el-form-item label="手机号" prop="value" label-width="80px">
            <el-input
              v-model="dialogValue1.value"
              autocomplete="off"
              placeholder="请输入手机号"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="showUserNameDialog = false">取 消</el-button>
          <el-button type="primary" @click="editUserName">确 定</el-button>
        </div>
      </el-dialog>
      <!-- 修改用户名弹窗 -->
      <el-dialog
        title="修改用户名称"
        width="25%"
        top="30vh"
        :center="true"
        :close-on-click-modal="false"
        :visible.sync="showRealNameDialog"
        @close="dialogValue2.value = ''"
      >
        <el-form :model="dialogValue2">
          <el-form-item label="用户名称" prop="value" label-width="80px">
            <el-input
              v-model="dialogValue2.value"
              autocomplete="off"
              placeholder="请输入用户名称"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="showRealNameDialog = false">取 消</el-button>
          <el-button type="primary" @click="editRealName">确 定</el-button>
        </div>
      </el-dialog>
      <!-- 修改工作邮箱 -->
      <el-dialog
        title="设置邮箱"
        width="25%"
        top="30vh"
        :center="true"
        :close-on-click-modal="false"
        :visible.sync="showEmailDialog"
        @close="dialogValue4.value = ''"
      >
        <el-form :model="dialogValue4">
          <!-- <el-form-item label="工作邮箱" prop="value" label-width="80px"> -->
          <el-input
            v-model="dialogValue4.value"
            autocomplete="off"
            placeholder="请输入工作邮箱"
          ></el-input>
          <!-- </el-form-item> -->
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="showEmailDialog = false">取 消</el-button>
          <el-button type="primary" @click="editEmail">确 定</el-button>
        </div>
      </el-dialog>
      <!-- 修改密码弹窗 -->
      <el-dialog
        title="修改密码"
        width="25%"
        top="30vh"
        :center="true"
        :close-on-click-modal="false"
        :visible.sync="showPasswordDialog"
        @close="
          dialogValue3 = {
            oldPassword: '',
            newPassword: '',
            rePassword: '',
          }
        "
      >
        <el-form :model="dialogValue3" :rules="passwordRules" ref="passwordRef">
          <el-form-item label="旧密码" prop="oldPassword" label-width="100px">
            <el-input
              v-model.trim="dialogValue3.oldPassword"
              autocomplete="off"
              type="password"
              show-password
              placeholder="请输入旧密码"
            ></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="newPassword" label-width="100px">
            <el-input
              v-model.trim="dialogValue3.newPassword"
              autocomplete="off"
              type="password"
              show-password
              placeholder="请输入新密码"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="确认新密码"
            prop="rePassword"
            label-width="100px"
          >
            <el-input
              v-model.trim="dialogValue3.rePassword"
              autocomplete="off"
              type="password"
              show-password
              placeholder="请确认新密码"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="showPasswordDialog = false">取 消</el-button>
          <el-button type="primary" @click="editPassword">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { userEditAdmin } from "@/api/userApi";
export default {
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.dialogValue3.newPassword) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      // 圆形图片
      circleUrl: require("@/assets/images/useravatar@2x.png"),
      cameraIcon: require("@/assets/images/camera@2x.png"),
      avatar: "",
      id: "",
      realName: "",
      create_time: "",
      roleName: "",
      LastloginTime: "",
      userName: "",
      password: "",
      email: "",
      showUserNameDialog: false,
      showRealNameDialog: false,
      showEmailDialog: false,
      showPasswordDialog: false,
      dialogValue1: {
        value: "",
      },
      dialogValue2: {
        value: "",
      },
      dialogValue4: {
        value: "",
      },
      dialogValue3: {
        oldPassword: "",
        newPassword: "",
        rePassword: "",
      },
      passwordRules: {
        oldPassword: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            pattern:
              /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()_+-/~=?])[A-Za-z\d!@#$%^&*()_+-/~=?]{8,16}$/,
            message: "请输入8~16位密码且至少包含一位数字、字母和特殊字符",
            trigger: "blur",
          },
        ],
        newPassword: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          {
            pattern:
              /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()_+-/~=?])[A-Za-z\d!@#$%^&*()_+-/~=?]{8,16}$/,
            message: "请输入8~16位密码且至少包含一位数字、字母和特殊字符",
            trigger: "blur",
          },
        ],
        rePassword: [{ validator: validatePass, trigger: "blur" }],
      },
      fromAccountList: false,
    };
  },
  created() {
  },
  mounted() {
    console.log("this.$store.state", this.$store.state.userInfo);
    console.log("this.$route.query", this.$route.query);

    if (this.$route.query.fromAccountList) {
      this.fromAccountList = true;
      let query = this.$route.query;
      let id = JSON.parse(query.params);
      this.getAccountInfo(id);
    }
  },
  methods: {
    getAccountInfo(id) {
      this.$get("/user/admin/get", {
        id,
      }).then((res) => {
        if (res.data.code === 1000) {
          let data = res.data.data;
          this.avatar = data.avatar;
          this.id = data.id;
          this.realName = data.realName;
          this.create_time = data.createTimeString;
          this.email = data.email;
          this.LastloginTime = data.LastLoginTime;
          this.userName = data.userName;
          const roleList = data.roleList; // 解析 roleList
          console.log("roleList", roleList);
          if (roleList.length > 0) {
            this.roleName = roleList.map((role) => role.name).join("、");
          }
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
          });
        }
      });
    },
    encryptPhoneNumber(phoneNumber) {
      if (phoneNumber && phoneNumber.length === 11) {
        return phoneNumber.substring(0, 3) + "****" + phoneNumber.substring(7);
      } else if (!phoneNumber) {
        return "";
      }
      return phoneNumber; // 如果手机号长度不为11，直接返回原始号码
    },
    showDialog(type) {
      if (type === "userName") {
        this.showUserNameDialog = true;
        this.dialogValue1.value = this.userName;
      } else if (type === "realName") {
        this.showRealNameDialog = true;
        this.dialogValue2.value = this.realName;
      } else if (type === "email") {
        this.showEmailDialog = true;
        this.dialogValue4.value = this.email;
      } else if (type === "password") {
        this.showPasswordDialog = true;
        // this.dialogValue3.oldPassword = this.password;
      }
    },
    async editUserName() {
      const formData = new FormData();
      formData.append("id", this.id);
      formData.append("userName", this.dialogValue1.value);
      const { data } = await userEditAdmin(formData);
      if (data.code === 1000) {
        this.userName = this.dialogValue1.value;
        this.showUserNameDialog = false;
        this.afterEditInfoSync(data.data.data);
      } else {
        this.$message.error(data.msg);
      }
    },
    async editRealName() {
      const formData = new FormData();
      formData.append("id", this.id);
      formData.append("realName", this.dialogValue2.value);
      const { data } = await userEditAdmin(formData);
      if (data.code === 1000) {
        this.realName = this.dialogValue2.value;
        this.showRealNameDialog = false;
        this.afterEditInfoSync(data.data.data);
      } else {
        this.$message.error(data.msg);
      }
    },
    async editEmail() {
      const EMAIL_EXP =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // 邮箱校验
      if (!EMAIL_EXP.test(this.dialogValue4.value)) {
        this.$message.error("请输入有效的邮箱");
        return;
      }

      const formData = new FormData();
      formData.append("id", this.id);
      formData.append("email", this.dialogValue4.value);
      const { data } = await userEditAdmin(formData);
      if (data.code === 1000) {
        this.email = this.dialogValue4.value;
        this.showEmailDialog = false;
        this.afterEditInfoSync(data.data.data);
      } else {
        this.$message.error(data.msg);
      }
    },
    editPassword() {
      console.log(this.dialogValue3);
      this.$refs.passwordRef.validate(async (valid) => {
        if (valid) {
          const formData = new FormData();
          formData.append("id", this.id);
          formData.append("oldPassword", this.dialogValue3.oldPassword);
          formData.append("password", this.dialogValue3.newPassword);
          const { data } = await userEditAdmin(formData);
          if (data.code === 1000) {
            this.showPasswordDialog = false;
            this.$message.success("修改成功");
          } else {
            this.$message.error(data.msg);
          }
        }
      });
    },
    // 更换头像
    changeAvatar() {
      console.log("this.fromAccountList", this.fromAccountList);

      if (this.fromAccountList) return;
      oFile.click();
      const that = this;

      function handleFileChange(e) {
        const file = e.target.files[0];
        const formData = new FormData();
        formData.append("id", that.id);
        formData.append("avatar", file);

        userEditAdmin(formData)
          .then(({ data }) => {
            if (data.code === 1000) {
              console.log("addEventListener", data.data.data);
              that.avatar = data.data.data.avatar;
              that.afterEditInfoSync(data.data.data);
            } else {
              that.$message.error(data.msg);
            }
            // 清除事件监听器
            oFile.removeEventListener("change", handleFileChange);
          })
          .catch((error) => {
            that.$message.error("上传失败"); // 处理其他错误
            oFile.removeEventListener("change", handleFileChange);
          });
      }

      oFile.addEventListener("change", handleFileChange);
    },
    afterEditInfoSync(userInfo) {
      // console.log("afterEditInfoSync");
      // localStorage.setItem("userInfo", JSON.stringify(userInfo));
      // this.$store.commit("changeUserInfo", userInfo);
    },
  },
};
</script>

<style lang="less" scoped>
.personalInfo {
  width: 100%;
  height: 100% - 30px;
  .detail-head {
    box-sizing: border-box;
    display: flex;
    // align-items: center;
    width: 100%;
    height: 174px;
    padding-top: 34px;
    padding-left: 40px;
    background-color: #fff;
    .avator {
      position: relative;
      width: 100px;
      height: 100px;
      .camera {
        display: inline-block;
        position: absolute;
        bottom: 0;
        right: 0;
        width: 32px;
        height: 32px;
        border-radius: 50%;
        background-color: #f2f3f5;
        .cameraIcon {
          width: 18px;
          height: 18px;
          padding-top: 7px;
          padding-left: 7px;
        }
      }
    }
    .info-keys {
      text-align: right;
      width: 156px;
      color: #86909c;
    }
    .info-values {
      width: 224px;
      padding-left: 16px;
      .detail-edit {
        color: #165dff;
        padding-left: 16px;
      }
    }
  }
  .detail-body {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    margin-top: 16px;
    padding: 20px;
    background-color: #fff;
    .type-button {
      display: inline-block;
      width: 88px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      border-radius: 16px;
      margin-right: 12px;
      color: #4e5969;
    }
    .active-button {
      color: #165dff;
      background-color: #f2f3f5;
    }
    .detail-item {
      display: flex;
      padding-top: 40px;
      .item-title {
        width: 70px;
        padding-left: 20px;
        padding-right: 16px;
      }
      .item-content {
        flex: 1;
        display: flex;
        justify-content: space-between;
        margin-right: 24px;
        padding-bottom: 30px;
        border-bottom: 1px solid #e5e6eb;
        .content-info {
          color: #86909c;
        }
        .content-edit {
          color: #165dff;
          cursor: pointer;
        }
      }
    }
  }
}
.user-info {
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 0 30px 120px;
  box-sizing: border-box;
  width: 75%;
  ::v-deep .el-descriptions-item__label {
    width: 60px;
    text-align: right !important;
    color: #86909c;
  }
  ::v-deep .el-descriptions-item__content {
    color: #1d2129;
    font-weight: 400;
  }
}
</style>
